import styled, { keyframes } from 'styled-components';
import { IonRouterLink } from '@ionic/react';

const hue = keyframes`
 from {
   -webkit-filter: hue-rotate(166deg);
 }
 to {
   -webkit-filter: hue-rotate(-194deg);
 }
`;

export const NavbarHead = styled.section`
  justify-content: space-between;
  align-items: center;
  display: flex;
  position: fixed;
  top: 0;
  width: 100%;
  
  @media (max-width: 768px) {
    background-color: transparent;
    height: 4rem;
    justify-content: flex-end;
    right: 2rem;
    z-index: 100;
    padding: 5rem 0 0 1.5rem ;
  }

  @media (min-width: 768px) {
    background-color: black;
    opacity: 0.94;
    height: 4rem;
    z-index: 10;
    padding: 0 1.5rem;
  }
  
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
`;


export const Navigation = styled.nav`
  display: flex;
  font-size: 1.1rem;
  color: darkcyan;
  justify-content: center;
  align-items: center;
  gap: 2rem 1.5rem;
  flex: 1;
  z-index: 2;

  @media (max-width: 768px) {
    display: none;
  }
`;


export const Links = styled(IonRouterLink)`
  text-decoration: none;
  margin: 5px 20px;
  font-size: 1.1rem;
  background-image: -webkit-linear-gradient(92deg, #f35626, #feab3a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-animation: ${hue} 8s infinite linear;
  color: purple;
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  display: flex;
  z-index: 2;
  justify-content: space-evenly;
`;

export const Burger = styled.div`
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 25px;
  cursor: pointer;
  z-index: 20;
 
  @media (max-width: 768px) {
    display: flex;
  }

  div {
    width: 100%;
    height: 4px;
    background: #feab3a;
    border-radius: 10px;
    transition: all 0.3s linear;
    transform-origin: 1px;

    &:nth-child(1) {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    &:nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(-20px)' : 'translateX(0)'};
    }

    &:nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

export const MobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 25;
  right: 0;
  height: 100vh;
  width: 70%;
  background-color: black;
  opacity: 0.8;
  transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(100%)'};
  transition: transform 0.3s ease-in-out;
  padding-top: 5rem;
  padding-left: 2rem;
  z-index: 15;

  a {
    padding: 1rem 0;
    font-size: 1.3rem;
    justify-content: space-between;
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

export const Overlay = styled.div`
  display: ${({ open }) => open ? 'block' : 'none'};
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
`;

export const UserData = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  justify-items: space-between;
`